declare var window: any;

const Confirm = {
  openDialog(this: any, message: string) {
    const modal = document.getElementById("confirmation-popup");
    if (modal) {
      modal.querySelector("[data-popup-message]")!.textContent = message;
      window.liveSocket.execJS(modal, modal.getAttribute("data-exec-open"));
    }
  },
  mounted(this: any) {
    const element = this.el;

    element.addEventListener("click", (e: any) => {
      const preventConfirm = e.target.hasAttribute("phx-no-confirm");
      if (preventConfirm) return;

      const message = element.getAttribute("phx-confirm");
      if (!message) {
        throw new Error("Attribute phx-confirm is not set");
      }

      if (e.isTrusted) {
        e.stopPropagation();
        e.preventDefault(); // To prevent submits for submit buttons
        const callback = () => {
          e.target.dispatchEvent(new PointerEvent("click", { bubbles: true }));
        };
        this.openDialog(message);
        window.addEventListener("phx:confirm", callback, { once: true });
        window.addEventListener("phx:cancel", () => {
          window.removeEventListener("phx:confirm", callback);
        });
      }
    });
  },
};

export default Confirm;
